import React from 'react';
import PropTypes from 'prop-types';
import {
  makeStyles,
  Dialog,
  Box,
  Typography,
  DialogContent,
  IconButton,
} from '@material-ui/core';
import { Close as CloseIcon } from '@material-ui/icons';
import moment from 'moment';
import { useTranslation } from 'react-i18next';

import { formatCurrencyValue } from '../../../utils';

import styles from './styles';

const useStyles = makeStyles(styles);

const DialogClosedShiftDetails = ({ open, onClose, data }) => {
  const { t } = useTranslation('common');
  const classes = useStyles();

  return (
    <Dialog
      disableBackdropClick
      disableEscapeKeyDown
      aria-labelledby="dialog-closed-shift-details"
      open={open}
      keepMounted
      maxWidth={false}
      classes={{
        container: classes.container,
        paperWidthFalse: classes.paper,
      }}
      scroll="body"
    >
      <Box className={classes.header}>
        <Typography component="h2" className={classes.title}>
          {t('payments.shift.closeShiftDetails.title')}
        </Typography>

        <IconButton
          aria-label="close"
          onClick={onClose}
          className={classes.closeButton}
        >
          <CloseIcon color="secondary" />
        </IconButton>
      </Box>

      <DialogContent className={classes.content}>
        <Typography component="p" className={classes.text}>
          <b>{t('payments.shift.closeShiftDetails.opening')}</b>{' '}
          {moment(data.started_at).format('DD/MM/YYYY HH:mm')}
        </Typography>

        <Typography component="p" className={classes.text}>
          <b>{t('payments.shift.closeShiftDetails.closing')}</b>{' '}
          {moment(data.ended_at).format('DD/MM/YYYY HH:mm')}
        </Typography>

        <Typography
          component="p"
          className={classes.text}
          style={{ marginTop: 12 }}
        >
          <b>{t('payments.shift.closeShiftDetails.totalsByCurrency')}</b>
        </Typography>

        {data.currencies.length === 0 && (
          <Typography component="p" className={classes.text}>
            {t('payments.shift.closeShiftDetails.noPaymentsRecorded')}
          </Typography>
        )}

        {data.currencies.map((currency) => (
          <Typography
            key={`currency-${currency.currency_id}`}
            component="p"
            className={classes.text}
          >
            <b>{currency.currency_id.toUpperCase()}:</b>{' '}
            {formatCurrencyValue(currency.amount, { style: 'decimal' })}
          </Typography>
        ))}
      </DialogContent>
    </Dialog>
  );
};

DialogClosedShiftDetails.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  data: PropTypes.shape({
    started_at: PropTypes.string,
    ended_at: PropTypes.string,
    currencies: PropTypes.arrayOf(
      PropTypes.shape({
        currency_id: PropTypes.string,
        amount: PropTypes.string,
      }),
    ),
  }),
};

DialogClosedShiftDetails.defaultProps = {
  data: null,
};

export default DialogClosedShiftDetails;
